import { render, staticRenderFns } from "./AvailableLabourSundry.vue?vue&type=template&id=28a8a289&scoped=true"
import script from "./AvailableLabourSundry.vue?vue&type=script&lang=js"
export * from "./AvailableLabourSundry.vue?vue&type=script&lang=js"
import style0 from "./AvailableLabourSundry.vue?vue&type=style&index=0&id=28a8a289&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8a289",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a8a289')) {
      api.createRecord('28a8a289', component.options)
    } else {
      api.reload('28a8a289', component.options)
    }
    module.hot.accept("./AvailableLabourSundry.vue?vue&type=template&id=28a8a289&scoped=true", function () {
      api.rerender('28a8a289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/components/sundryItemsComponents/AvailableLabourSundry.vue"
export default component.exports